export declare namespace InspectionParticipantSectionTokenSections {
	interface SectionTitle {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}

	interface SectionSubtitle {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}

	interface TableHeader {
		color: string;
		fontSize: string;
		lineHeight: string;
	}

	interface RowBorder {
		borderColor: string;
	}

	interface EmptyRule {
		borderColor: string;
	}

	interface Cell {
		color: string;
		fontSize: string;
		lineHeight: string;
	}

	interface CellNumber {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}

	interface SignatureCell {
		background: string;
		color: string;
		fontSize: string;
		lineHeight: string;
		padding: string;
		borderRadius: string;
		minHeight: string;
		refusalLabel: {
			color: string;
		};
	}

	interface AddLink {
		display: string;
		alignItems: string;
		gap: string;
		padding: string;
		fontSize: string;
		lineHeight: string;
		fontWeight: string;
		color: string;
		hoverColor: string;
	}
}

export type InspectionParticipantSectionTokens = {
	gap: string;
	tableMinWidth: string;
	sectionTitle: InspectionParticipantSectionTokenSections.SectionTitle;
	sectionSubtitle: InspectionParticipantSectionTokenSections.SectionSubtitle;
	tableHeader: InspectionParticipantSectionTokenSections.TableHeader;
	rowBorder: InspectionParticipantSectionTokenSections.RowBorder;
	emptyRule: InspectionParticipantSectionTokenSections.EmptyRule;
	cell: InspectionParticipantSectionTokenSections.Cell;
	cellNumber: InspectionParticipantSectionTokenSections.CellNumber;
	signatureCell: InspectionParticipantSectionTokenSections.SignatureCell;
	addLink: InspectionParticipantSectionTokenSections.AddLink;
};

export const sectionTitle: InspectionParticipantSectionTokenSections.SectionTitle = {
	color: '{surface.950}',
	fontSize: '18px',
	fontWeight: '600',
	lineHeight: '30px',
};

export const sectionSubtitle: InspectionParticipantSectionTokenSections.SectionSubtitle = {
	color: '{text.muted.color}',
	fontSize: '16px',
	fontWeight: '400',
	lineHeight: '26px',
};

export const tableHeader: InspectionParticipantSectionTokenSections.TableHeader = {
	color: '{text.muted.color}',
	fontSize: '14px',
	lineHeight: '24px',
};

export const rowBorder: InspectionParticipantSectionTokenSections.RowBorder = {
	borderColor: '{surface.200}',
};

export const emptyRule: InspectionParticipantSectionTokenSections.EmptyRule = {
	borderColor: '{surface.100}',
};

export const cell: InspectionParticipantSectionTokenSections.Cell = {
	color: '{surface.950}',
	fontSize: '14px',
	lineHeight: '24px',
};

export const cellNumber: InspectionParticipantSectionTokenSections.CellNumber = {
	color: '{surface.950}',
	fontSize: '16px',
	fontWeight: '500',
	lineHeight: '26px',
};

export const signatureCell: InspectionParticipantSectionTokenSections.SignatureCell = {
	background: '{surface.50}',
	color: '{text.muted.color}',
	fontSize: '14px',
	lineHeight: '24px',
	padding: '8px',
	borderRadius: '{border.radius.md}',
	minHeight: '40px',
	refusalLabel: {
		color: '{form.field.invalid.border.color}',
	},
};

export const addLink: InspectionParticipantSectionTokenSections.AddLink = {
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	padding: '8px 16px',
	fontSize: '14px',
	lineHeight: '24px',
	fontWeight: '400',
	color: '{primary.color}',
	hoverColor: '{primary.hover.color}',
};

/**
 * Participant step sections (officers, representatives, other) — Figma 5964-135983.
 * Semantic tokens; layout/spacing per design.
 */
export default {
	gap: '2rem',
	tableMinWidth: '720px',
	sectionTitle,
	sectionSubtitle,
	tableHeader,
	rowBorder,
	emptyRule,
	cell,
	cellNumber,
	signatureCell,
	addLink,
} satisfies InspectionParticipantSectionTokens;
